


/**
 * Proper case a string
 * @param str 
 * @returns the string in proper case
 */
export function toProperCase(str?: string | null): string {
    if (!str) return "";
    return str.split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
}
